'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TagPill = require('./components/TagPill.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TagPill).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/tag-pill/lib/index.js
// module id = 1548
// module chunks = 1